module.exports = __webpack_public_path__ + "static/media/news-single.8cecb9c5.jpg";